import React, { Component } from "react"
import { Switch, Tag, Tooltip } from "antd"
import { get, truncate } from "lodash"
import threePoints from "../../images/three-points.svg"
import threePointsGray from "../../images/three-points-gray.svg"

class SwitchRender extends Component {
  state = { isLoadingQuestion: false }

  render() {
    return (
      <Switch
        disabled={this.props.disabled}
        loading={this.state.isLoadingQuestion}
        checked={this.props.checked}
        onChange={(e) => {
          this.setState({ isLoadingQuestion: true })
          const params = {
            idQuestion: this.props.enps
              ? this.props.item.data[0].id_question_has_dimension
              : this.props.item.id_question_has_dimension,
            params: { enabled: e ? 1 : 0 },
          }

          setTimeout(() => {
            this.setState({ isLoadingQuestion: false })
          }, 2000)
          this.props.updateQuestionDimensionWatcher(params)
        }}
      />
    )
  }
}

class DimensionBoxEnps extends Component {
  state = { isLoadingSurvey: false }

  render() {
    const { item } = this.props

    return (
      <div className="dimension-box">
        <div className="dimension-box-header">
          <div className="dimension-box-division">
            <div className="dimension-box-division-left">
              {get(item.meta, "icon_url", "") && (
                <img src={get(item.meta, "icon_url", "")} />
              )}
              <div className="dimension-box-division-titleBox">
                <span className="dimension-box-division-titleDefault">
                  {get(item.meta, "title", "")}
                </span>
              </div>
            </div>
            <div className="dimension-box-division-right">
              {!this.props.hideSwitch && (
                <React.Fragment>
                  <Switch
                    disabled={!!this.props.measures.length}
                    loading={this.state.isLoadingSurvey}
                    style={{
                      marginRight: !this.props.hideThreePoints ? 37 : 0,
                    }}
                    checked={
                      this.props.enps
                        ? item.data[0].enabled
                        : item.meta.qualitative_enabled
                    }
                    onChange={(e) => {
                      this.setState({ isLoadingSurvey: true })
                      const nameSelected = this.props.enps
                        ? "idQuestion"
                        : "idSurvey"
                      const params = {
                        [nameSelected]: this.props.enps
                          ? item.data[0].id_question_has_dimension
                          : this.props.idSurvey,
                        params: { enabled: e ? 1 : 0 },
                      }

                      setTimeout(() => {
                        this.setState({ isLoadingSurvey: false })
                      }, 1800)
                      if (this.props.enps) {
                        this.props.updateQuestionDimensionWatcher(params)
                      } else {
                        this.props.updateQualitativeWatcher(params)
                      }
                    }}
                  />
                  {this.props.hideThreePoints && (
                    <Tooltip placement="top" title="Editar dimensión">
                      <div
                        className="dbox-dots"
                        onClick={() => {
                          const itemFat = this.props.enps
                            ? item.data[0].id_question
                            : item.question_id_question
                          const typesFat = this.props.enps
                            ? item.data[0].id_survey
                            : item.id_survey
                          this.props.getQuestionTypesWatcher(typesFat)
                          this.props.getQuestionWatcher(itemFat)
                          this.props.toggleDrawer("questionsDrawer", true)
                          window.Intercom('update', { hide_default_launcher: true})
                          Intercom("close")
                        }}>
                        <img
                          src={
                            (this.props.enps
                              ? item.data[0].enabled
                              : item.meta.qualitative_enabled)
                              ? threePoints
                              : threePointsGray
                          }
                        />
                      </div>
                    </Tooltip>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
          <ul className="questions-ul">
            {get(item, "data", []).map((item, index) => {
              return (
                <li key={index}>
                  <div className="questions-li">
                    <span
                      className="questions-li-title"
                      style={{ color: item.enabled ? "" : "#C4C4C4" }}>
                      {truncate(item.name, { length: 128 })}
                      {item.required && (<span className='required'>*</span>)}
                      {!item.required && <Tag className="tagQuestion" color="default">Opcional</Tag>}
                    </span>
                    {!this.props.hideSwitch && (
                      <div className="questions-li-actions">
                        {this.props.showOptionsChildren && (
                          <React.Fragment>
                            <SwitchRender
                              enps={this.props.enps}
                              item={item}
                              disabled={!!this.props.measures.length}
                              checked={item.enabled}
                              updateQuestionDimensionWatcher={
                                this.props.updateQuestionDimensionWatcher
                              }
                            />
                            <Tooltip placement="top" title="Editar preguntas">
                              <div
                                className="dbox-dots"
                                onClick={() => {
                                  this.props.getQuestionTypesWatcher(
                                    item.id_survey
                                  )
                                  this.props.getQuestionWatcher(
                                    item.id_question
                                  )
                                  this.props.toggleDrawer(
                                    "questionsDrawer",
                                    true
                                  )
                                  window.Intercom('update', { hide_default_launcher: true})
                                  Intercom("close")
                                }}>
                                <img
                                  src={
                                    item.enabled ? threePoints : threePointsGray
                                  }
                                />
                              </div>
                            </Tooltip>
                          </React.Fragment>
                        )}
                      </div>
                    )}
                  </div>
                    {item.question_segments !== undefined && (
                      <div className="segments">
                      {item.question_segments.map((d, di) => (
                        <span className="span-segments"> <b>- {d.segment}:</b> {d.name}</span>
                      ))}
                    </div>)
                    }
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

export default DimensionBoxEnps
